import React, { useCallback, useEffect } from "react"
import { FaDeleteLeft } from "react-icons/fa6"

import { delay } from "utils"
import classes from "./PinCodeKeyPads.module.scss"

const pads = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "del", "0", "پاک"]

const PinCodeKeyPads = props => {
  const {
    pin,
    code,
    setPin,
    setShowError,
    onSuccess,
    onFailed
  } = props

  const validatePin = async (pin) => {
    if (code === pin) {
      await delay(200)


      setShowError(false)

      await delay(400)

      setPin("")

      onSuccess()
    } else {
      setPin("")

      setShowError(true)

      onFailed()
    }
  }

  const handlePress = pad => {
    if (!pad) return

    if (pad === "پاک") return setPin("")

    if (pad === "del") {
      setPin(prev =>
        prev.substring(0, prev.length - 1)
      )

      return
    }

    const newPin = pin + pad

    setPin(newPin)

    if (newPin.length === 4) validatePin(newPin)
  }

  const handleKeyPress =
    useCallback((e) => {
      let key = ""

      if (!isNaN(e.key)) {
        key = e.key
      }

      if (e.key === "Backspace") {
        key = "del"
      }

      if (e.key === "Delete") {
        key = "پاک"
      }

      if (key === "") return

      handlePress(key)
    }, [pin])

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress)

    return () => {
      window.removeEventListener("keydown", handleKeyPress)
    }
  }, [pin])

  return (
    <div className={classes["container"]}>
      {pads.map(pad =>
        <button
          key={pad}
          className={classes["pad"]}
          onClick={() => handlePress(pad)}
        >
          {pad === "del" ? <FaDeleteLeft /> : pad}
        </button>
      )}
    </div>
  )
}

export default PinCodeKeyPads